import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(
  'f1c301b5628c65d90aa1f7fb64d99a6eTz0xMzMzMDAsRT0xODIxODMwMzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MixBVD1zaW5nbGUsS1Y9Mg==',
);
